export default {
  bid: {
    offering: {
      required: 'Offering required',
    },
    interestRate: {
      required: 'Interest Rate required',
      shouldBeNumber: 'Should be number',
      moreThanZero: 'Should be more than 0',
    },
    upfrontCharges: {
      required: 'Charges required',
      shouldBeNumber: 'Should be number',
      minimum: 'Should be positive number or 0',
    },
  },
  buyerRegistration: {
    email: {
      invalid: 'Incorrect Email',
      required: 'Email required',
    },
    password: {
      required: 'Password required',
      minLength: 'The password must contain at least 8 characters',
    },
  },
  loanOfficerRegistration: {
    email: {
      invalid: 'Incorrect Email',
      required: 'Email required',
    },
    password: {
      required: 'Password required',
      minLength: 'The password must contain at least 8 characters',
    },
    passwordConfirmation: {
      passwordMatch: 'Passwords not match',
      required: 'Password confirmation required',
    },
    nmls: {
      required: 'NMLS required',
    },
  },
  realEstateAgentRegistration: {
    email: {
      invalid: 'Incorrect Email',
      required: 'Email required',
    },
    password: {
      required: 'Password required',
      minLength: 'The password must contain at least 8 characters',
    },
    passwordConfirmation: {
      passwordMatch: 'Passwords not match',
      required: 'Password confirmation required',
    },
    mls: {
      required: 'License number required',
    },
  },
  login: {
    email: {
      invalid: 'Incorrect Email',
      required: 'Email required',
    },
    password: {
      required: 'Password required',
      minLength: 'The password must contain at least 8 characters',
    },
  },
  updatePassword: {
    password: {
      required: 'Password required',
      minLength: 'The password must contain at least 8 characters',
    },
    passwordConfirmation: {
      passwordMatch: 'Passwords not match',
      required: 'Password confirmation required',
    },
  },
  profileSettings: {
    email: {
      invalid: 'Incorrect Email',
      required: 'Email required',
      maxLength: 'The email must be no more than 50 characters.',
    },
  },
  buyerProfile: {
    email: {
      invalid: 'Incorrect Email',
      required: 'Email required',
      maxLength: 'The email must be no more than 50 characters.',
    },
    firstName: {
      maxLength: 'The first name must be no more than 50 characters.',
    },
    lastName: {
      maxLength: 'The last name must be no more than 50 characters.',
    },
    phoneNumber: {
      invalid: 'Phone number is invalid',
    },
  },
  resetPassword: {
    password: {
      required: 'Password required',
      minLength: 'The password must contain at least 8 characters',
    },
    passwordConfirmation: {
      passwordMatch: 'Passwords not match',
      required: 'Password confirmation required',
    },
  },
  realEstateAgentProfile: {
    email: {
      invalid: 'Incorrect Email',
      required: 'Email required',
      maxLength: 'The email must be no more than 50 characters.',
    },
    firstName: {
      maxLength: 'The first name must be no more than 50 characters.',
    },
    lastName: {
      maxLength: 'The last name must be no more than 50 characters.',
    },
    company: {
      maxLength: 'The company name must be no more than 50 characters.',
    },
    mls: {
      required: 'License number required',
    },
  },
  loanOfficerAutoFollowupsMessageesForm: {
    firstMessage: {
      maxLength: 'The message must be no more than 250 characters.',
    },
    secondMessage: {
      maxLength: 'The message must be no more than 250 characters.',
    },
    thirdMessage: {
      maxLength: 'The message must be no more than 250 characters.',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/validations.js